import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, GlobalStyles, Slide } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router-dom';
import bgImage from '../../Assets/bg1.png';

const LandingPage = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setChecked(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!checked) {
      const slideDuration = 500;
      const navTimer = setTimeout(() => {
        navigate('/login');
      }, slideDuration);
      return () => clearTimeout(navTimer);
    }
  }, [checked, navigate]);

  return (
    <>
      <GlobalStyles
        styles={{
          html: { height: '100%' },
          body: { height: '100%', margin: 0, padding: 0 },
          '#root': { height: '100%' },
        }}
      />

      <Slide direction="right" in={checked} mountOnEnter unmountOnExit timeout={500}>
        <Box
          sx={{
            height: '100vh',
            width: '100%',
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: `'Poppins', sans-serif`,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              backdropFilter: 'blur(4px)',
              zIndex: 1,
            }}
          />

          <Box
            sx={{
              position: 'relative',
              zIndex: 2,
              width: '100%',
              maxWidth: 300,
              px: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Typography
              variant="h4"
              fontWeight={600}
              sx={{
                color: '#fff',
                fontFamily: `'Poppins', sans-serif`,
                mb: 1,
                fontSize: '2.2rem',
                lineHeight: 1.2,
              }}
            >
              Experience
            </Typography>
            <Typography
              variant="h4"
              fontWeight={600}
              sx={{
                color: '#fff',
                fontFamily: `'Poppins', sans-serif`,
                mb: 6,
                fontSize: '2.2rem',
                lineHeight: 1.2,
              }}
            >
              the best hotel stays
            </Typography>

            <Button
              variant="contained"
              sx={{
                alignSelf: 'center',
                borderRadius: '50%',
                width: 56,
                height: 56,
                minWidth: 'unset',
                backgroundColor: '#004d4d',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)',
                '&:hover': {
                  backgroundColor: '#003737',
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
              }}
            >
              <EastIcon sx={{ fontSize: 24, color: '#fff' }} />
            </Button>
          </Box>
        </Box>
      </Slide>
    </>
  );
};

export default LandingPage;
